export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/index/resources/computed.js